'use client';

import type { JSX } from 'react';

/**
 * Barre de progression du tunnel d'achat de carte cadeau (miroir de `BookingProgress`).
 * Affiche un remplissage linéaire `(index + 1) / total`. Masquée s'il n'y a qu'une étape.
 */
export function GiftCardProgress({ currentIndex, total }: { currentIndex: number; total: number }): JSX.Element | null {
  if (total <= 1) return null;
  const progress = ((currentIndex + 1) / total) * 100;
  return (
    <div className="bt-progress">
      <div className="bt-progress__bar">
        <div className="bt-progress__fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
